import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AuthFormStep, } from '@as-react/common-types';
import DpeAuth from '../dpe-auth/DpeAuth';
import DpeTile from '../dpe-tile/DpeTile';
import { Image, Box, BoxTheme } from '@as/cotopaxi';
const DpePopup = ({ data, digitalPartner, onConfirmationClick, onEnrolmentStepUpdate, isAuthenticated, authFormStep, onFormValidationError, onAuthFormStepUpdate, onLogin, loginState, }) => {
    return (_jsxs(_Fragment, { children: [(isAuthenticated || authFormStep === AuthFormStep.EMAIL || authFormStep === AuthFormStep.LOGIN) && (_jsx(DpeTile, { isPopup: true, isAuthenticated: isAuthenticated, data: data.tileData, digitalPartner: digitalPartner, onConfirmationClick: onConfirmationClick, onActiveStepChange: onEnrolmentStepUpdate, onFormValidationError: onFormValidationError })), !isAuthenticated && (_jsx(Box, { mobile: {
                    spacing: {
                        paddingTop: (authFormStep === AuthFormStep.LOGIN || authFormStep === AuthFormStep.EMAIL) && 3,
                        paddingBottom: 2,
                        paddingLeft: 2,
                        paddingRight: 2,
                    },
                    theme: authFormStep === AuthFormStep.LOGIN || authFormStep === AuthFormStep.EMAIL
                        ? BoxTheme.PRIMARY
                        : BoxTheme.NONE,
                }, tablet: {
                    spacing: {
                        paddingTop: (authFormStep === AuthFormStep.LOGIN || authFormStep === AuthFormStep.EMAIL) && 3,
                        paddingBottom: 4,
                        paddingLeft: 4,
                        paddingRight: 4,
                    },
                }, children: _jsxs(_Fragment, { children: [(authFormStep === AuthFormStep.LOGIN || authFormStep === AuthFormStep.EMAIL) && (_jsx(Box, { mobile: {
                                spacing: {
                                    paddingBottom: 1,
                                },
                            }, children: _jsx(Image, { src: data.authData.logo, alt: digitalPartner, height: 60 }) })), _jsx(DpeAuth, { data: data.authData, step: authFormStep, onStepUpdate: onAuthFormStepUpdate, onLogin: onLogin, loginState: loginState, onValidationError: errorMessage => {
                                onFormValidationError(Object.assign({}, errorMessage));
                            } })] }) }))] }));
};
export { DpePopup };
